export const supportedVersions = [1] as const;

export const latestVersion = supportedVersions[0];
